import React, { Component } from "react";
import { Spin, message, Radio, Space } from "antd";
import Bridge from "../../../utils/Bridge";
import { speech_demographics_form_type } from "../../../utils/consts";
import moment from "moment";

export default class NonAlsUsersForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      als_user_type:"",
      options:[],
      label:"",
      mgh_data_id:0,
      non_als_obj:{},
      is_record_present:0,
      email:"",
      neurostamp_id:"",
      modality_id:"",
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    this.setState({loading:true})
    let params = "?participants_accounts_id=" + localStorage.getItem("ap_participants_accounts_id")+'&type='+speech_demographics_form_type.non_als_user;
    Bridge.demographics.speech
      .get(params)
      .then((response) => {
        if (response.status == "1") {
          for(let item of response.data){
            if(item.form=='Non-ALS Users'){
              this.setState({
                mgh_data_id:item.mgh_data_id,
                non_als_obj:item,
                is_record_present: 1,
                als_user_type:item.value
              })
            }
          }
          this.setState({
            label:response.field_data.no_als_user_options[0].field_label,
            options:response.field_data.no_als_user_options,
            email:response.email,
            neurostamp_id:response.neurostamp_id,
            modality_id:response.modality_id,
            loading:false
          })
        }else{
          this.setState({loading:false})
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  // step 1
  save_details = () => {
    if (!this.state.als_user_type) {
      message.warning("Choose one option!");
      return;
    }
    let params = {
      mgh_data_id: this.state.mgh_data_id,
      value: this.state.als_user_type,
      non_als_obj:{
        form: "Non-ALS Users",
        view_name: this.state.options[0].view_name,
        field: this.state.options[0].field,
        value: this.state.als_user_type,
        subject: 0,
        record_id:0,
        record_edit_date:moment().format('MM/DD/YYYY HH:mm:ss A'),
        email:this.state.email,
        neurostamp_id:this.state.neurostamp_id,
        modality_id:this.state.modality_id,
      },
      step: speech_demographics_form_type.non_als_user,
      is_record_present: this.state.is_record_present,
      action_type: this.props.is_update == true ? "update" : "insert",
      email:this.state.email,
      neurostamp_id:this.state.neurostamp_id,
      modality_id:this.state.modality_id,
    };
    this.setState({ loading: true });
    Bridge.demographics.speech
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                this.props.set_active_step(2);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  render() {
    return (
      <div>
        <div className="header">
          <h3 className="text-uppercase">Non-ALS Users</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <div className="form-group">
              <label className="input-heading">
                {this.state.label}{" "}
                <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={(e) =>
                  this.setState({ als_user_type: e.target.value })
                }
                value={this.state.als_user_type}
                direction="vertical"
              >
                <Space direction="vertical">
                  {this.state.options.map((item,index)=>{
                    return (
                      <Radio value={item.values} key={index}>{item.description}</Radio>
                    )
                  })}
                </Space>
              </Radio.Group>
            </div>
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 0,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save_details()}
                >
                  Save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{
                    padding: "9px 28px 10px 21px",
                    background: "#b3b3b3",
                    cursor: "auto",
                  }}
                  className="submit-button"
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Previous
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save_details()}
                >
                  Save & Next{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
